export enum FuelType {
  DIESEL = 'diesel',
  LNG = 'lng',
  DIESEL_LNG = 'diesel-lng',
  LNG_DIESEL = 'lng-diesel',
  PHEV = 'phev',
  EV = 'ev',
}
